

export class AvailableColumn {

    constructor(public value: string, public label: string) {
        
    }

}